@if (userStore.initialized() && userStore.isLoggedIn()) {
  <app-authenticated-view></app-authenticated-view>
}
<app-tool-overlay [class]="sidebarService.contentSize$()"></app-tool-overlay>
<app-help-dialog></app-help-dialog>
